import { render, staticRenderFns } from "./recipient-employee-id.vue?vue&type=template&id=ca2730d8"
import script from "./recipient-employee-id.vue?vue&type=script&lang=js"
export * from "./recipient-employee-id.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports